"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isVertical = exports.isRTL = exports.isIntrinsic = exports.isHorizontal = exports.isFixed = exports.getTabPanelId = exports.getTabId = void 0;
var _constants = require("./constants");
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

const getTabId = (uid, key) => `tabs-${uid}-tab-${key}`;
exports.getTabId = getTabId;
const getTabPanelId = (uid, key) => `tabs-${uid}-tabpanel-${key}`;
exports.getTabPanelId = getTabPanelId;
const isHorizontal = orientation => orientation === _constants.ORIENTATION.horizontal;
exports.isHorizontal = isHorizontal;
const isVertical = orientation => orientation === _constants.ORIENTATION.vertical;
exports.isVertical = isVertical;
const isRTL = direction => direction === 'rtl';
exports.isRTL = isRTL;
const isIntrinsic = fill => fill === _constants.FILL.intrinsic;
exports.isIntrinsic = isIntrinsic;
const isFixed = fill => fill === _constants.FILL.fixed;
exports.isFixed = isFixed;